<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-form-item label="班组名称" style="margin-right:15px">
        <el-input v-model="form.name" :disabled="true" />
      </el-form-item>
      <el-form-item label="力别" style="margin-right:15px">
        <el-input v-model="form.forceTypeName" :disabled="true" />
      </el-form-item>

      <!-- <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="所属机构" style="margin-right:15px">
              <el-input v-model="form.partyGroupCode" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
      </el-row> -->
      <el-form-item label="所属部门" style="margin-right:15px">
        <el-select v-model="form.departmentCode" placeholder="请选择所属部门" disabled style="width:100%">
          <el-option v-for="item in departmentList" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'TeamDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        name: '',
        forceTypeName:'',
        partyGroupCode: '',
        departmentCode: ''
      },
      departmentList: []
    }
  },
  created() {
    this.findDepartmentList()
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 查询部门
    findDepartmentList() {
      request({ url: `/ntocc-basic-api/department`, method: 'get' }).then(response => {
        this.departmentList = response.data.records
      })
    },
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/team/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin-top: 50px;
    }
</style>
